export const ROCK = 'Rock';
export const PAPER = 'Paper';
export const SCISSORS = 'Scissors';

export const USER = 'user';
export const COMP = 'comp';
export const DRAW = 'draw';

export const MAX_LIVES = 5;
